import { render, staticRenderFns } from "./recyclingData.vue?vue&type=template&id=0ff67ed7&scoped=true"
import script from "./recyclingData.vue?vue&type=script&lang=js"
export * from "./recyclingData.vue?vue&type=script&lang=js"
import style0 from "./recyclingData.vue?vue&type=style&index=0&id=0ff67ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff67ed7",
  null
  
)

export default component.exports